import { TUnknownParam } from '@utils/diff/helpers';

export type TConstructorTypeOf<T> = new (...args: ISerializable[]) => T;

export enum EDebuggableModuleState {
  OK = 'ok',
  ERROR = 'error',
}

export type TDebuggableAdditionalInfo = TUnknownParam;

export interface IDebbugable {
  status: string;
  additionalInfo: TDebuggableAdditionalInfo;
  state: EDebuggableModuleState;
  additionalModules?: Record<string, IDebbugable>;
  groups?: string[];
}

export type TAvailableConfigValues<T> = Partial<Record<keyof T, { isMultiple: boolean; values: string[] }>>;

export type TDeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: TDeepPartial<T[P]>;
    }
  : T;

type TJSONValue = string | number | boolean | symbol | IJSONObject | TJSONArray;

interface IJSONObject {
  [x: string]: TJSONValue;
}

export interface ISerializable {
  [x: string]: TJSONValue | null | undefined | ISerializable;
}

type TJSONArray = Array<TJSONValue>;
